export interface EMSNSortForm {
  sortBy: 'claimType' | 'eMSNDate'
  sortOrder: 'ascending' | 'descending'
}

export const defaultEMSNSortForm: EMSNSortForm = {
  sortBy: 'eMSNDate',
  sortOrder: 'descending'
}
